import { Variants } from "framer-motion";
import { ANIMATION_CONFIG, ANIMATION_STATE, LOOP_CONFIG } from "./constants";
import {
  calculatePulseLoopTimes,
  getExitTransition,
} from "./helpers";

const {
  PULSE_CYCLE_DURATION,
  BONUS_TEXT_Y_SHIFT_OUT,
} = ANIMATION_CONFIG;

// --- Keyframes for Gift Text (Similar to BonusText) ---
const TEXT_Y_BASE = -8;
const TEXT_Y_UP_SMALL = TEXT_Y_BASE;
const TEXT_Y_UP_BIG = TEXT_Y_BASE - BONUS_TEXT_Y_SHIFT_OUT;

const yKeyframesGiftText = [
  -20,
  TEXT_Y_BASE,
  TEXT_Y_BASE,
  TEXT_Y_BASE,
  TEXT_Y_BASE,
  TEXT_Y_UP_BIG,
  TEXT_Y_UP_BIG,
  TEXT_Y_UP_SMALL,
  TEXT_Y_UP_SMALL,
  TEXT_Y_UP_BIG,
  TEXT_Y_UP_BIG,
  TEXT_Y_UP_SMALL,
  TEXT_Y_UP_SMALL,
  TEXT_Y_UP_BIG,
  TEXT_Y_UP_BIG,
  TEXT_Y_UP_SMALL,
  TEXT_Y_UP_SMALL,
  TEXT_Y_BASE,
  TEXT_Y_BASE,
];

const opacityKeyframesGiftText = [
  0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
];

const opacityKeyframesFinalGlow = [
  0, 0, 0, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 0, 0,
];

const yKeyframesGiftText_PulseLoop = [
  yKeyframesGiftText[3],
  yKeyframesGiftText[4],
  yKeyframesGiftText[5],
  yKeyframesGiftText[6],
  yKeyframesGiftText[3],
];
const opacityKeyframesGiftText_PulseLoop = [
  opacityKeyframesGiftText[3],
  opacityKeyframesGiftText[4],
  opacityKeyframesGiftText[5],
  opacityKeyframesGiftText[6],
  opacityKeyframesGiftText[3],
];
const opacityKeyframesFinalGlow_PulseLoop = [
  opacityKeyframesFinalGlow[3],
  opacityKeyframesFinalGlow[4],
  opacityKeyframesFinalGlow[5],
  opacityKeyframesFinalGlow[6],
  opacityKeyframesFinalGlow[3],
];
const pulseLoopTimes = calculatePulseLoopTimes();

const yKeyframesGiftText_Enter = yKeyframesGiftText.slice(0, 4);
const opacityKeyframesGiftText_Enter = opacityKeyframesGiftText.slice(0, 4);
const opacityKeyframesFinalGlow_Enter = opacityKeyframesFinalGlow.slice(0, 4);

export const ftdGiftTextVariant: Variants = {
  [ANIMATION_STATE.IDLE]: {
    opacity: 0,
    y: 100,
  },
  [ANIMATION_STATE.ENTERING]: {
    opacity: [0, 1, 1, 1],
    y: [100, TEXT_Y_BASE, TEXT_Y_BASE, TEXT_Y_BASE],
    transition: {
      opacity: {
        delay: LOOP_CONFIG.INITIAL_DELAY / 1000,
        ease: "easeOut",
        duration: 0.2,
        times: [0, 0.5, 0.5, 1],
      },
      y: {
        delay: LOOP_CONFIG.INITIAL_DELAY / 1000,
        ease: "easeOut",
        duration: 0.2,
        times: [0, 1, 1, 1],
      },
    },
  },
  [ANIMATION_STATE.PULSING]: {
    opacity: opacityKeyframesGiftText_PulseLoop,
    y: yKeyframesGiftText_PulseLoop,
    transition: {
      opacity: {
        ease: "linear",
        duration: PULSE_CYCLE_DURATION,
        times: pulseLoopTimes,
        repeat: Infinity,
        repeatType: "loop",
      },
      y: {
        ease: "linear",
        duration: PULSE_CYCLE_DURATION,
        times: pulseLoopTimes,
        repeat: Infinity,
        repeatType: "loop",
      },
    },
  },
  exit: {
    opacity: 0,
    y: 100,
    transition: getExitTransition(),
  },
};

export const finalGlowVariant: Variants = {
  [ANIMATION_STATE.IDLE]: {
    opacity: 0,
    x: "-50%",
    y: 100,
  },
  [ANIMATION_STATE.ENTERING]: {
    opacity: [0, 0, 0, 0],
    x: "-50%",
    y: [100, 0, 0, 0],
    transition: {
      opacity: {
        delay: LOOP_CONFIG.INITIAL_DELAY / 1000,
        ease: "easeOut",
        duration: 0.2,
        times: [0, 0.3, 0.6, 1],
      },
      x: {
        duration: 0,
      },
      y: {
        delay: LOOP_CONFIG.INITIAL_DELAY / 1000,
        ease: "easeOut",
        duration: 0.2,
        times: [0, 1, 1, 1],
      },
    },
  },
  [ANIMATION_STATE.PULSING]: {
    opacity: opacityKeyframesFinalGlow_PulseLoop,
    x: "-50%",
    y: 0,
    transition: {
      opacity: {
        ease: "linear",
        duration: PULSE_CYCLE_DURATION,
        times: pulseLoopTimes,
        repeat: Infinity,
        repeatType: "loop",
      },
    },
  },
  exit: {
    opacity: 0,
    x: "-50%",
    y: 100,
    transition: getExitTransition(),
  },
};

export const initialGlowVariant: Variants = {
  [ANIMATION_STATE.IDLE]: {
    opacity: 0,
    x: "-50%",
    y: 100,
    transition: { duration: 0 },
  },
  [ANIMATION_STATE.ENTERING]: {
    opacity: [0, 1],
    x: "-50%",
    y: [100, 0],
    transition: {
      opacity: { ease: "easeOut", duration: 0.2 },
      y: { ease: "easeOut", duration: 0.4 },
      x: { duration: 0 },
    },
  },
  [ANIMATION_STATE.PULSING]: {
    opacity: 1,
    x: "-50%",
    y: 0,
    transition: { duration: 0 },
  },
  exit: {
    opacity: 0,
    x: "-50%",
    y: 100,
    transition: getExitTransition(),
  },
};
